import React, { useRef, useEffect, Component, useCallback } from 'react'
import { useLocation } from 'react-router-dom'
import { MobXProviderContext } from 'mobx-react'
import { StoreType } from '@/store'

// 获取浏览器 ?后面的参数
export function useQuery() {
  const query: { [x: string]: string } = {}
  const search = useLocation().search
  const params = new URLSearchParams(search)
  params.forEach((val, key) => {
    query[key] = val
  })
  return query
}
interface ContextType {
  store: StoreType
}

// 函数声明，重载
function useStores(): StoreType
function useStores<T extends keyof StoreType>(storeName: T): StoreType[T]

/**
 * 获取根 store 或者指定 store 名称数据
 * @param storeName 指定子 store 名称
 * @returns typeof StoreType[storeName]
 */
function useStores<T extends keyof StoreType>(storeName?: T) {
  const rootStore = React.useContext(MobXProviderContext)
  const { store } = rootStore as ContextType
  return storeName ? store[storeName] : store
}

/**
 * 动态设置页面 document title
 * @param title 页面标题
 * @param retainOnUnmount 页面离开是否保持，默认 false
 */
export function useDocumentTitle(title: string, retainOnUnmount = false) {
  const defaultTitle = useRef(document.title)

  useEffect(() => {
    console.log('set title:', title)
    document.title = title
  }, [title])

  useEffect(() => {
    return () => {
      if (!retainOnUnmount) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        document.title = defaultTitle.current
      }
    }
  }, [retainOnUnmount])
}

export { useStores }
